import { VALUE_ENTER, VALUE_ESCAPE, WIZ_EVENT_TYPE,} from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizAgGrid,
  WizBasePopUp,
  WizDatasource,
  WizEvent, WizEventManager
} from '@wizeoo/akm-component-lib';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Column } from 'ag-grid-community';
import { WidgetLine } from '@wizeoo/akm-compute-lib';

import { FeiVO } from '../../../../vo/workingdata/fei.vo';
import { IWidget } from '../../../../manager/widgets/i-widget';
import { Model } from '../../../../model/model';

/** contrat d'interface pour les données manipulée dans cette PopUp */
export interface BaselineFormChooserParams {
  updateCallback: Function; // la callback pour retour
  widget: IWidget; // le pivot source pour prise en compte du mode "conf"
  sourceDS:  WizDatasource<WidgetLine>; // la liste source
}

@Component({
  // popUp de sélection de baseline dans le formulaire d'édition
  selector: 'baseline-form-choose-pop',
  templateUrl: './baseline-form-choose.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaselineFormChoosePop extends WizBasePopUp {
  
  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ENTER) {
      this.save();
    }
    if (event.key === VALUE_ESCAPE) {
      this.doCancel();
    }
  }

  @ViewChild('agGrid') agGrid: WizAgGrid<WidgetLine>;
  @ViewChild('filter', { read: FilterComponent }) filter: FilterComponent; // filtre

  public declare datas: BaselineFormChooserParams;
  public static baseWidth: string = '500px';
  public static baseHeight: string = '300px';

  public lineDS: WizDatasource<WidgetLine> = new WizDatasource<WidgetLine>([]) // DS de la liste
    //.setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setFilter(this.filterFunc.bind(this))
    .setSelectionMode('single')
    .build();


  public get model(): Model {
    return this.datas.widget.model;
  }


  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  show(): void {
    this.feedDatasources();
    this.addListeners();
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
  
    setTimeout(() => {
      // on attend que tout soit prêt...
      // d'abord les colonnes, elles forment la clé d'aggrégat
      this.agGrid.api.setColumnDefs([]); // on rince les colonnes
      this.agGrid.api.setColumnDefs(this.model.feiEngine.buildColumnsForMassEdit(this.datas.widget.fei as FeiVO, this.datas.widget)); // générer les colonnes depuis le contexte
      this.lineDS.setSource(this.datas.sourceDS.getWorkedSource()); // alimentation de la DS des lignes // avec un max
      this.lineDS.select(this.datas.sourceDS.selectedItems);
    }, 0);

  
    // construction du filtre
    // TODO champ dyna ?
    // this.filter.configure(['code', 'parentCode', 'trsLabel', 'trsLabelWithParent'], null, null).build();
    this.filter.configure(['key'], null, null).build();
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.filter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre des mesures & function
  }

  // filterFunc de la collection de fdv
  protected filterFunc(item: WidgetLine): boolean {
    let result: boolean = false;
    if (!this.filter.basicValue) {
      return true;
    }

    const fei: FeiVO = this.datas.widget.fei as FeiVO;
    // let rawval:{ [key: string]: string } = BaselineEngine.feedAllKeys( fei, item.bl); // on s'assure que les trios sont alimentés sur la BL
    let render: string;
    this.agGrid.columnApi.getAllColumns().forEach((col: Column) => {
      render = item.rendererMap.get(col.getInstanceId()).renderer?.get(undefined);
      if(render?.toLocaleUpperCase().includes(this.filter.basicValue?.toUpperCase())) {
        result = true;
        return; // on sort de la fonction
      }    
    }); 
 
    return result;
  }

  /**
   * modification du filtre des fdv
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.lineDS.refresh();
  }

  /** Sauvegarde, même valeur */
  public save(): void {
    let val: WidgetLine = this.lineDS.selectedItem;
    this.datas.updateCallback(val);
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public hide() {
    WizEventManager.removeListener(this, this.filter, WIZ_EVENT_TYPE.FILTER);
    super.hide();
  }
}
